import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const backendTokenGuard: CanActivateFn = (route) => {
  const token = route.queryParamMap.get('token');

  return token?.trim() ? true : inject(Router).createUrlTree(['/login']);
};

export const registrationPendingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const navigationState = router.getCurrentNavigation()?.extras.state;
  const email = navigationState?.['email'];

  return typeof email === 'string' && email.trim()
    ? true
    : router.createUrlTree(['/login']);
};
